const StoriesPlayIcon = () => {
  // viewBox = '0 0 85 85';
  return (
    <g>
      <circle
        id='Ellipse 13'
        cx='42.5'
        cy='42.5'
        r='42.5'
        transform='rotate(-180 42.5 42.5)'
        fill='white'
        fillOpacity='0.4'
      />
      <path
        id='Vector'
        d='M50.6115 37.4817L50.6134 37.4828C53.2513 39.0203 54.3036 40.8837 54.3036 42.5032C54.3036 44.1226 53.2513 45.9861 50.6134 47.5235L50.6115 47.5246L46.1527 50.134L41.6958 52.7423C41.6956 52.7424 41.6953 52.7426 41.6951 52.7427C39.055 54.2812 36.9459 54.2619 35.5752 53.4613C34.1994 52.6577 33.125 50.8092 33.125 47.7219V42.5032V37.2844C33.125 34.177 34.2008 32.3314 35.5733 31.5328C36.9424 30.7364 39.0519 30.7233 41.695 32.2636C41.6953 32.2637 41.6956 32.2639 41.6958 32.264L46.1527 34.8723L50.6115 37.4817Z'
        stroke='white'
        strokeWidth='2.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  );
};

export default StoriesPlayIcon;
